import React from "react";
import { Tooltip, Input, Avatar } from "@heroui/react";

const Sidebar = ({ items, activeId, onSelect, collapsed, onToggle }) => {
    return (
        <div
            className={`
        sticky top-0 h-screen z-40
        bg-white border-r border-gray-200
        flex flex-col justify-between
        transition-all duration-300 ease-in-out
        ${collapsed ? "w-20" : "w-64"}
      `}
        >
            {/* Top Section */}
            <div className="flex flex-col gap-6 p-4">
                {/* Logo */}
                <div className={`flex items-center ${collapsed ? "justify-center" : "gap-3 px-2"}`}>
                    <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-lg shadow-blue-200">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>
                    </div>
                    {!collapsed && (
                        <span className="font-bold text-xl text-gray-900 tracking-tight">Taasa</span>
                    )}
                </div>

                {/* Search Bar - Hide on collapse */}
                {!collapsed && (
                    <div className="relative group">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="h-4 w-4 text-gray-400 group-focus-within:text-blue-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                        <input
                            type="text"
                            placeholder="Search..."
                            className="block w-full pl-10 pr-3 py-2 border border-gray-200 rounded-lg leading-5 bg-gray-50 text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-all"
                        />
                    </div>
                )}

                {/* Navigation */}
                <nav className="space-y-1">
                    {items.map((item) => {
                        const isActive = activeId === item.id;
                        return (
                            <Tooltip
                                key={item.id}
                                content={collapsed ? item.label : ""}
                                placement="right"
                                isDisabled={!collapsed}
                            >
                                <button
                                    type="button"
                                    onClick={() => onSelect(item.id)}
                                    className={`
                    w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
                    ${collapsed ? "justify-center" : ""}
                    ${isActive
                                            ? "bg-blue-50 text-blue-700 shadow-sm ring-1 ring-blue-100"
                                            : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                                        }
                  `}
                                >
                                    <div className={`flex-shrink-0 transition-colors ${isActive ? "text-blue-600" : "text-gray-400"}`}>
                                        {item.icon}
                                    </div>
                                    {!collapsed && <span>{item.label}</span>}

                                    {/* Optional: Add badge if item has counts (mock logic) */}
                                    {!collapsed && item.id === 'requests' && (
                                        <span className="ml-auto bg-blue-100 text-blue-600 py-0.5 px-2 rounded-full text-xs font-semibold">3</span>
                                    )}
                                </button>
                            </Tooltip>
                        );
                    })}
                </nav>
            </div>

            {/* Bottom Section */}
            <div className="p-4 border-t border-gray-100 bg-gray-50/50">
                <button
                    onClick={onToggle}
                    className={`
              flex items-center gap-3 w-full p-2 rounded-lg 
              hover:bg-white hover:shadow-sm transition-all duration-200 text-gray-500 hover:text-gray-700
              ${collapsed ? "justify-center" : ""}
           `}
                >
                    {collapsed ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
                    ) : (
                        <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>
                            <span className="text-sm font-medium">Collapse Sidebar</span>
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
